import styled from '@emotion/styled'

export const PageContainer = styled.div`
    padding: 5rem;
    max-width: 1550px;
    margin: 0 auto;
`
